import React from 'react';
import { Form, Switch, Select } from 'antd';
import { SECTIONS } from '../templates/categories';

export const categoryOptions = SECTIONS.map((section) => ({
    label: section.label,
    title: section.label,
    options: section.children.map((child) => ({
        label: child.label,
        value: child.key,
    })),
}));

const TemplateMetaFields = ({ form, switchLabel = 'Catalog template', disabled = false, disabledHint }) => {
    const isTemplate = Form.useWatch('is_template', form);

    return (
        <>
            <Form.Item
                name="is_template"
                label={switchLabel}
                valuePropName="checked"
                extra={disabled && disabledHint ? disabledHint : undefined}
            >
                <Switch
                    disabled={disabled}
                    onChange={(checked) => {
                        if (!checked) {
                            form.setFieldValue('category', undefined);
                        } else {
                            // Templates and companies are mutually exclusive — no-op
                            // if the form has no company_id field
                            form.setFieldValue('company_id', undefined);
                        }
                    }}
                />
            </Form.Item>
            {isTemplate && (
                <Form.Item
                    name="category"
                    label="Category"
                    rules={[{ required: true, message: 'Pick a category' }]}
                >
                    <Select
                        placeholder="Select a category"
                        options={categoryOptions}
                        showSearch
                        optionFilterProp="label"
                    />
                </Form.Item>
            )}
        </>
    );
};

export default TemplateMetaFields;
